import { Flex } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  MoreForLessBenefit,
  MoreForLessBenefitVariant,
  MoreForLessEffect,
} from '../../../../typings'
import { DistributedTag } from '../../../promotions/MoreForLessForm/MoreForLessEffect/View/Benefit/AdvancedConfig/DistributedTag'
import { MostExpensiveTag } from '../../../promotions/MoreForLessForm/MoreForLessEffect/View/Benefit/AdvancedConfig/MostExpensiveTag'
import { messages } from '../messages'
import styles from './styles'

type DiscountProps = {
  discount: number
}

function DiscountPercent(props: DiscountProps) {
  const { discount } = props
  const { formatPercentual } = useNumbers()

  return (
    <Flex className={styles.flexRow}>
      <FormattedMessage
        {...messages.moreForLess.percentual}
        values={{
          discount: <Tag>{formatPercentual(discount)}</Tag>,
          tag: (content) => <Tag>{content}</Tag>,
        }}
      />
    </Flex>
  )
}

function DiscountMaxPrice(props: DiscountProps) {
  const { discount } = props
  const { formatCurrency } = useNumbers()

  return (
    <Flex className={styles.flexRow}>
      <FormattedMessage
        {...messages.moreForLess.maxPrice}
        values={{
          discount: <Tag>{formatCurrency(discount)}</Tag>,
          tag: (content) => <Tag>{content}</Tag>,
        }}
      />
    </Flex>
  )
}

type DetailsProps = {
  apply: MoreForLessBenefit['apply']
}

export function ItemsDetails(props: DetailsProps) {
  const { apply } = props
  const { $t } = useIntl()
  const {
    moreForLess: { advanced },
  } = messages
  return (
    <SummaryRow>
      <SummaryRow.Title>{$t(advanced.itemsDetails)}</SummaryRow.Title>
      <SummaryRow.Value className={styles.valueContent}>
        {apply.equals && <Tag>{$t(advanced.equals)}</Tag>}
        <MostExpensiveTag config={apply} />
      </SummaryRow.Value>
    </SummaryRow>
  )
}
export function DiscountDetails(props: DetailsProps) {
  const { apply } = props
  const { $t } = useIntl()
  const {
    moreForLess: { advanced },
  } = messages
  return (
    <SummaryRow>
      <SummaryRow.Title>{$t(advanced.discountDetails)}</SummaryRow.Title>
      <SummaryRow.Value className={styles.valueContent}>
        <DistributedTag config={apply} />
      </SummaryRow.Value>
    </SummaryRow>
  )
}

type Props = {
  benefit: MoreForLessEffect['benefit']
}

export function MoreForLessRow(props: Props) {
  const { benefit } = props

  if (!benefit) return null

  const {
    apply,
    discount: { type, value = 0 },
  } = benefit

  const isPercentual = type === MoreForLessBenefitVariant.PERCENTUAL

  return (
    <>
      <SummaryRow>
        <SummaryRow.Title>
          <FormattedMessage {...messages.discount.title} />
        </SummaryRow.Title>
        <SummaryRow.Value className={styles.valueContentColumn}>
          {isPercentual ? (
            <DiscountPercent discount={value} />
          ) : (
            <DiscountMaxPrice discount={value} />
          )}
        </SummaryRow.Value>
      </SummaryRow>
      <ItemsDetails apply={apply} />
      <DiscountDetails apply={apply} />
    </>
  )
}
